export const ROUTES = {
    DEFAULT_PATH: '/',
    HOMEPAGE_ROUTE: '/',
    LOGIN_ROUTE: '/login',
    REGISTER_ROUTE: '/register',
    SERVICE_CATALOGUE_ROUTE: '/service-catalog',
    LOGS_ROUTE: '/logs',
    TRACES_ROUTE: '/traces'
}